import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as e } from "react/jsx-runtime";
import t from "styled-components";
import { Row as o } from "react-styled-flexboxgrid";
var i = t.div.withConfig({
    displayName: "RowWrapper",
    componentId: "VDS__sc-1n498kw-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  n = t(o).withConfig({
    displayName: "StyledRow",
    componentId: "VDS__sc-1n498kw-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-width: 1272px;\n"]))),
  r = function r(t) {
    return e(i, {
      bleed: t.bleed,
      children: e(n, Object.assign({}, t, {
        children: t.children
      }))
    });
  };
export { r as default };